var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-minimize-icon-container"},[_c('a-icon',{staticClass:"minimize-icon",attrs:{"type":_vm.toggled ? 'right' : 'left'},on:{"click":_vm.toggleIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }